import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninRedirectCallbackComponent } from './signin-redirect-callback/signin-redirect-callback.component';
import { RedirectSilentRenewComponent } from './redirect-silent-renew/redirect-silent-renew.component';
import { SquirrelLayoutComponent } from 'projects/squirrel-layout/src/lib/squirrel-layout.component';
import { SignoutRedirectCallbackComponent } from './signout-redirect-callback/signout-redirect-callback.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '', component: SquirrelLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../../../squirrel-layout/src/lib/squirrel-layout.module').then((m) => m.SquirrelLayoutModule)
      }
    ]
  },
  { path: 'signin-callback', component: SigninRedirectCallbackComponent },
  { path: 'redirect-silentrenew', component: RedirectSilentRenewComponent },
  { path: 'signout', component: SignoutRedirectCallbackComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      // initialNavigation: 'enabled',
      // scrollPositionRestoration:'enabled',
      // anchorScrolling: 'enabled'
      //enableTracing: true,
      // initialNavigation:'enabled',

      //onSameUrlNavigation :'reload' // funktioniert nicht
    }
    //,{onSameUrlNavigation :'reload'}
  )],

  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() { }
}



